import { Interface } from '@ethersproject/abi'
import NFT_STAKING_ABI  from './nft_staking_rewards.json'

const NFT_STAKING_INTERFACE = new Interface(NFT_STAKING_ABI)

export { NFT_STAKING_INTERFACE }
